import * as React from 'react'
import { IExpenseCreate } from 'src/services/interfaces/Expense/IExpenseCreate'
import Title from '../Title';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Spin, Row } from 'antd';
import { useState, useContext, useEffect } from 'react';
import { ServiceContext } from 'src/services/provider/Service.provider';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import { ExpenseItemCard } from '../ExpenseItemCard/ExpenseItemCard';
import { IExpenseItemCreate } from 'src/services/interfaces/Expense/IExpenseItemCreate';
import { ExpenseCategoryEnum } from 'src/services/Enum/ExpenseCategoryEnum';
import { ExpenseAddTradeButton } from '../ExpenseAddTradeButton/ExpenseAddTradeButton';
import "./ExpenseRequestItemEdit.scss";

interface IExpenseRequestItemEdit2Props {
    expense: IExpenseCreate;
    onChange: (value: Partial<IExpenseCreate>) => void;
    form: WrappedFormUtils;
}

export const ExpenseRequestItemEdit: React.FC<IExpenseRequestItemEdit2Props> = ({
    expense,
    onChange,
    form
}) => {
    const { expenseRequestService } = useContext(ServiceContext);

    const [trades, setTrades] = useState<number[]>([]);
    const [loading, setLoading] = useState(false);

    const [items, setItems] = useState<IExpenseTradeItemCreate[]>([]);

    useEffect(() => {
        fetch();
    }, []);

    useEffect(() => {
        onChange({ items: items.sort((s) => s.tradeId) });
    }, [items]);

    useEffect(() => {
        if (expense?.items && items.length === 0) {
            setItems(expense.items);
        }
    }, [expense]);

    const handleRemove = (tradeId: number) => {
        setItems(items.filter((obj) => obj.tradeId !== tradeId));
    };

    const handleExpenseItemUpdate = (tradeId: number, value: IExpenseItemCreate) => {
        const oldItem = items.find(obj => obj.tradeId === tradeId);
        const listCategories = [...oldItem.listCategories, value];
        const updateItem: IExpenseTradeItemCreate = { ...oldItem, listCategories };

        const newListItems = items.filter(obj => obj.tradeId !== tradeId);
        setItems([...newListItems, updateItem]);
    };

    const handleExpenseItemDelete = (tradeId: number, category: ExpenseCategoryEnum) => {
        const oldItem = items.find(obj => obj.tradeId === tradeId);
        const listCategories = oldItem.listCategories.filter((obj) => obj.category !== category);
        const updateItem: IExpenseTradeItemCreate = { ...oldItem, listCategories };

        const newListItems = items.filter(obj => obj.tradeId !== tradeId);
        setItems([...newListItems, updateItem]);
    };

    const handleAddTradeItem = (list: IExpenseTradeItemCreate[]) => {
        setItems(list);
    }

    const fetch = () => {
        setLoading(true);

        expenseRequestService.getTrades()
            .then(setTrades)
            .catch((err) => ShowNotification.Error("Falha ao carregar lista", "Ocorreu um erro ao carregar a lista de trades. Tente novamente."))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <Title style={{ marginTop: "25px", marginBottom: "27px" }} preset="bolder" size={"h4"}>
                Itens
            </Title>

            <Spin spinning={loading}>
                <ExpenseAddTradeButton
                    form={form}
                    onChange={handleAddTradeItem}
                    setLoading={setLoading}
                    tradeIds={trades}
                    items={items}
                />
            </Spin>

            <Row gutter={32} className="view-item-cards">
                <>
                    {items.map((obj, i) => (
                        <ExpenseItemCard
                            expenseItem={obj}
                            onItemUpdate={handleExpenseItemUpdate}
                            onItemDelete={handleExpenseItemDelete}
                            form={form}
                            onRemove={handleRemove}
                        />
                    )
                    )}
                </>
            </Row>
        </>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseRequestItemEdit/ExpenseRequestItemEdit.tsx